<template>
  <div class="dialog-box" v-if="dialogState" @click.self="_dialogClose">
    <div class="dialog-panel"
         :style="{width: wth + 'px',height: hth + 'px'}">
      <div class="dialog-header clearfix">
        <div class="dialog-title">
          {{title}}
        </div>
        <div class="button-close" @click="dialogClose">X</div>
      </div>
      <div class="dialog-body">
        <slot>

        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dialogPanel",
  props:{
    dialogState:{
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default:'titel_name'
    },
    wth:{
      type: String,
      default: '600'
    },
    hth:{
      type: String,
      default: '400'
    }
  },

  methods:{
    dialogClose: function (){
      this.$emit("event-dialog-close")
    }
  }
}
</script>

<style scoped>
.dialog-box{
  position: fixed;
  height: 100vh;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  /*background-color: red;*/
  z-index: 9999;
}
.dialog-panel{
  position: relative;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 5px;
  background-color: #fff;
  color: #1e1e1e;
}
.dialog-header{
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  background-color: #efefef;
}
.dialog-title{
  float: left;
  margin-left: 10px;
  font-size: 18px;
  font-weight: bold;
}
.button-close{
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
.dialog-body{
  width: 100%;
  height: 100%;
}


</style>
